import { Injectable } from '@angular/core';
import { OrderSignerResponse } from '@shared/types/order-signer-response.interface';

@Injectable({ providedIn: 'root' })
export class SignerPrefetchStateService {
  private data: OrderSignerResponse | null = null;
  private expiryTimer: ReturnType<typeof setTimeout> | null = null;

  set(response: OrderSignerResponse): void {
    this.data = response;
  }

  consume(): OrderSignerResponse | null {
    const data = this.data;
    this.clear();
    return data;
  }

  private clear(): void {
    this.data = null;
  }
}
